<h2 mat-dialog-title class="modal-add-header"><mat-icon class="with-text">add</mat-icon>เพิ่มจุดบริการ</h2>
<form [formGroup]="fg" (ngSubmit)="onSubmit()" #form>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ชื่อจุดบริการ</mat-label>
      <input matInput formControlName="name" placeholder="ชื่อจุดบริการที่ใช้ในการแสดงผล">
      <mat-error *ngIf="fg.get('name').getError('required')">{{ e.addServiceRequiredName }}</mat-error>
    </mat-form-field>
    <br>
    <mat-form-field>
      <mat-label>เลขรหัสของจุดบริการ</mat-label>
      <input matInput formControlName="displayId" placeholder="เลขรหัสของจุดบริการ">
      <mat-error *ngIf="fg.get('displayId').getError('required')">{{ e.addServiceRequiredDisplayId }}</mat-error>
      <mat-error *ngIf="fg.get('displayId').getError('duplicate')">{{ e.addServiceDuplicateDisplayId}}</mat-error>
    </mat-form-field>
    <br>
    <mat-form-field>
      <mat-label>พิกัดของจุดบริการ</mat-label>
      <input matInput
       formControlName="latlong" placeholder="ละติจูด,ลองจิจูด">
      <mat-error *ngIf="fg.get('latlong').getError('required')">{{ e.addServiceRequiredLatLong }}</mat-error>
      <mat-error *ngIf="fg.get('latlong').getError('pattern')">{{ e.addServicePatternLatLong }}</mat-error>
      </mat-form-field>
    <br>
    <br>

    <!-- <mat-form-field>
      <mat-label>เบอร์ติดต่อ</mat-label>
      <input matInput placeholder="เบอร์ติดต่อ">
    </mat-form-field>  -->
    <!-- <mat-grid-list cols="2" rowHeight="2:1">
        <mat-grid-tile>
            <mat-form-field>
                <mat-label>วันทำการ</mat-label>
                <input matInput placeholder="วันทำการ">
              </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field>
                <mat-label>เวลาทำการ</mat-label>
                <input matInput placeholder="เวลาทำการ">
              </mat-form-field>
        </mat-grid-tile>
    </mat-grid-list> -->
    <!-- <br>
    <mat-radio-group formControlName="numStatuses">
        <label>จำนวนสถานะ</label>
        <br>
      <mat-radio-button class="radio-multi-line" [value]="6">
        6 สถานะ
        <span class="sublabel">
          (Queue Receive / SQ Call / Check In / ABS Call / Pendding / Close)
        </span>
      </mat-radio-button>
      <mat-radio-button class="radio-multi-line" [value]="7">
          7 สถานะ
          <span class="sublabel">
            (Queue Receive / SQ Call / Queue Scan / Check In / ABS Call / Pendding / Close)
          </span>
        </mat-radio-button>
    </mat-radio-group> -->
    
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-spacer"></div>
    <button mat-raised-button mat-dialog-close [mat-dialog-close]="false">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button">บันทึก</button>
  </mat-dialog-actions>
</form>